export default "__VITE_ASSET__BbLclSkz__"